import React, { useState } from "react";
import Modal from "../Gallery/Modal";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

function ServiceGallery({ serviceType }) {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [modalImageTitle, setModalImageTitle] = useState("");

  // Service type'a göre görseller
  const serviceImages = {
    "single-room": [
      "/assets/img/yurt-fotograf/tek-kisilik/tek-kisilik-kiz-ogrenci-odasi-1-105.jpg",
      "/assets/img/yurt-fotograf/tek-kisilik/tek-kisilik-kiz-ogrenci-yurt-odasi-1-106.jpg",
      "/assets/img/yurt-fotograf/tek-kisilik/fatih-kiz-ogrenci-yurdu-1-107.jpg",
      "/assets/img/yurt-fotograf/tek-kisilik/odalarimizdan-manzara-1-37.jpg",
      "/assets/img/yurt-fotograf/tek-kisilik/duzenli-kisisel-esyalar-1-38.jpg",
      "/assets/img/yurt-fotograf/tek-kisilik/odalardaki-wc-ve-lavabolar-1-35.jpg",
    ],
    "double-room": [
      "/assets/img/2-3-kisilik-yatay/2-3-kisilik-yatay (1).jpeg",
      "/assets/img/2-3-kisilik-yatay/2-3-kisilik-yatay (2).jpeg",
      "/assets/img/2-3-kisilik/2-3-kisilik-dikey (3).jpeg",
      "/assets/img/2-3-kisilik/2-3-kisilik-dikey (4).jpeg",
      "/assets/img/yurt-fotograf/2-kisilik/aydinlik-ve-sehir-manzarali-1-31.jpg",
      "/assets/img/yurt-fotograf/2-kisilik/odalarimizdan-gorunum-1-23.jpg",
    ],
    "triple-room": [
      "/assets/img/2-3-kisilik-yatay/2-3-kisilik-yatay (3).jpeg",
      "/assets/img/2-3-kisilik-yatay/2-3-kisilik-yatay (4).jpeg",
      "/assets/img/2-3-kisilik/2-3-kisilik-dikey (5).jpeg",
      "/assets/img/2-3-kisilik/2-3-kisilik-dikey (6).jpeg",
      "/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/10.jpg",
      "/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/13.jpg",
      "/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/20.jpg",
      "/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/26.jpg",
      "/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/31.jpg",
      "/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/54.jpg",
      "/assets/img/yurt-fotograf/3-kisilik-on-108/37.jpg",
      "/assets/img/yurt-fotograf/3-kisilik-arka-cephe/29.jpg",
      "/assets/img/yurt-fotograf/3-kisilik-arka-cephe/34.jpg",
      "/assets/img/yurt-fotograf/3-kisilik-arka-cephe/44.jpg",
    ],
    "quad-room": [
      "/assets/img/yurt-fotograf/3-kisilik-on-cephe-106/54.jpg",
      "/assets/img/yurt-fotograf/3-kisilik-on-108/37.jpg",
      "/assets/img/yurt-fotograf/3-kisilik-arka-cephe/29.jpg",
      "/assets/img/yurt-fotograf/3-kisilik-arka-cephe/34.jpg",
      "/assets/img/yurt-fotograf/banyo/55.jpg",
    ],
    "six-room": [
      "/assets/img/yurt-fotograf/3-kisilik-arka-cephe/44.jpg",
      "/assets/img/yurt-fotograf/yemekhane/6.jpg",
      "/assets/img/yurt-fotograf/teras/8.jpg",
      "/assets/img/yurt-fotograf/etut/2.jpg",
      "/assets/img/yurt-fotograf/dis-cephe/40.jpg",
    ],
    "social-areas": [
      "/assets/img/yurt-fotograf/yemekhane/5.jpg",
      "/assets/img/yurt-fotograf/yemekhane/6.jpg",
      "/assets/img/yurt-fotograf/yemekhane/42.jpg",
      "/assets/img/yurt-fotograf/yemekhane/56.jpg",
      "/assets/img/yurt-fotograf/yemekhane/59.jpg",
      "/assets/img/yurt-fotograf/yemekhane/60.jpg",
      "/assets/img/yurt-fotograf/yemekhane/61.jpg",
      "/assets/img/yurt-fotograf/teras/7.jpg",
      "/assets/img/yurt-fotograf/teras/8.jpg",
      "/assets/img/yurt-fotograf/teras/9.jpg",
      "/assets/img/yurt-fotograf/teras/38.jpg",
      "/assets/img/yurt-fotograf/teras/39.jpg",
      "/assets/img/yurt-fotograf/teras/41.jpg",
      "/assets/img/yurt-fotograf/etut/1.jpg",
      "/assets/img/yurt-fotograf/etut/2.jpg",
      "/assets/img/yurt-fotograf/etut/3.jpg",
      "/assets/img/yurt-fotograf/dis-cephe/33.jpg",
      "/assets/img/yurt-fotograf/dis-cephe/36.jpg",
      "/assets/img/yurt-fotograf/dis-cephe/40.jpg",
      "/assets/img/yurt-fotograf/dis-cephe/53.jpg",
    ],
    // transportation: [
    //   "/assets/img/gallery/gallery_7_1.jpg",
    //   "/assets/img/gallery/gallery_7_2.jpg",
    //   "/assets/img/gallery/gallery_7_3.jpg",
    //   "/assets/img/gallery/gallery_7_4.jpg",
    // ],
    transportation: [],
    // "nearby-places": [
    //   "/assets/img/gallery/gallery_8_1.jpg",
    //   "/assets/img/gallery/gallery_8_2.jpg",
    //   "/assets/img/gallery/gallery_8_3.jpg",
    //   "/assets/img/gallery/gallery_8_4.jpg",
    // ],
    "nearby-places": [],
    "nearby-universities": [
      "/assets/img/üniversiteler/indir.png",
      "/assets/img/üniversiteler/indir (1).png",
      "/assets/img/üniversiteler/indir (2).png",
      "/assets/img/üniversiteler/indir.jfif",
      "/assets/img/üniversiteler/indir (1).jfif",
    ],
  };

  const images = serviceImages[serviceType] || serviceImages["single-room"];

  const serviceTypes = {
    "single-room": "singleRoom",
    "double-room": "doubleRoom",
    "triple-room": "tripleRoom",
    "quad-room": "quadRoom",
    "six-room": "sixRoom",
    "social-areas": "socialAreas",
    transportation: "transportation",
    "nearby-places": "nearbyPlaces",
    "nearby-universities": "nearbyUniversities",
  };

  const currentService = serviceTypes[serviceType] || "singleRoom";

  // Görsel için alt ve title metinlerini oluştur
  const getImageAltAndTitle = (imageSrc, index) => {
    const baseTitle = t(`service.${currentService}.title`);

    // Görsel yoluna göre özel açıklamalar
    if (imageSrc.includes("yemekhane")) {
      return {
        alt: `${baseTitle} - ${t("service.diningHall.title")} ${index + 1}`,
        title: `${baseTitle} - ${t("service.diningHall.title")} ${index + 1}`,
      };
    }
    if (imageSrc.includes("teras")) {
      return {
        alt: `${baseTitle} - ${t("service.terrace.title")} ${index + 1}`,
        title: `${baseTitle} - ${t("service.terrace.title")} ${index + 1}`,
      };
    }
    if (imageSrc.includes("banyo")) {
      return {
        alt: `${baseTitle} - ${t("service.bathroom.title")} ${index + 1}`,
        title: `${baseTitle} - ${t("service.bathroom.title")} ${index + 1}`,
      };
    }
    if (imageSrc.includes("dis-cephe")) {
      return {
        alt: `${baseTitle} - ${t("service.exterior.title")} ${index + 1}`,
        title: `${baseTitle} - ${t("service.exterior.title")} ${index + 1}`,
      };
    }
    if (imageSrc.includes("3-kisilik-on-cephe-106")) {
      return {
        alt: `${baseTitle} - ${t("service.tripleRoomFront106.title")} ${
          index + 1
        }`,
        title: `${baseTitle} - ${t("service.tripleRoomFront106.title")} ${
          index + 1
        }`,
      };
    }
    if (imageSrc.includes("3-kisilik-on-108")) {
      return {
        alt: `${baseTitle} - ${t("service.tripleRoomFront108.title")} ${
          index + 1
        }`,
        title: `${baseTitle} - ${t("service.tripleRoomFront108.title")} ${
          index + 1
        }`,
      };
    }
    if (imageSrc.includes("3-kisilik-arka-cephe")) {
      return {
        alt: `${baseTitle} - ${t("service.tripleRoomBack.title")} ${index + 1}`,
        title: `${baseTitle} - ${t("service.tripleRoomBack.title")} ${
          index + 1
        }`,
      };
    }
    if (imageSrc.includes("etut")) {
      return {
        alt: `${baseTitle} - ${t("service.studyRoom.title")} ${index + 1}`,
        title: `${baseTitle} - ${t("service.studyRoom.title")} ${index + 1}`,
      };
    }
    if (imageSrc.includes("tek-kisilik")) {
      return {
        alt: `${baseTitle} - ${t("service.singleRoom.title")} ${index + 1}`,
        title: `${baseTitle} - ${t("service.singleRoom.title")} ${index + 1}`,
      };
    }
    if (imageSrc.includes("2-kisilik")) {
      return {
        alt: `${baseTitle} - ${t("service.doubleRoom.title")} ${index + 1}`,
        title: `${baseTitle} - ${t("service.doubleRoom.title")} ${index + 1}`,
      };
    }
    if (imageSrc.includes("2-3-kisilik")) {
      // Yeni 2-3 kişilik odalar resimleri
      if (currentService === "doubleRoom") {
        return {
          alt: `${baseTitle} - ${t("service.doubleRoom.title")} ${index + 1}`,
          title: `${baseTitle} - ${t("service.doubleRoom.title")} ${index + 1}`,
        };
      }
      if (currentService === "tripleRoom") {
        return {
          alt: `${baseTitle} - ${t("service.tripleRoom.title")} ${index + 1}`,
          title: `${baseTitle} - ${t("service.tripleRoom.title")} ${index + 1}`,
        };
      }
    }

    // Varsayılan
    return {
      alt: `${baseTitle} - ${t("nav.generalPhotos")} ${index + 1}`,
      title: `${baseTitle} - ${t("nav.generalPhotos")} ${index + 1}`,
    };
  };

  const openModal = (imageSrc, event) => {
    event.preventDefault();
    const imageInfo = getImageAltAndTitle(imageSrc, 0);
    setModalImage(imageSrc);
    setModalImageTitle(imageInfo.title);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div className="gallery-area space-top">
      <div className="container th-container shape-mockup-wrap">
        {/* Başlık - Ulaşım Kolaylığı ve Yakın Mekanlar için kaldırıldı */}
        {serviceType === "transportation" ||
        serviceType === "nearby-places" ? null : (
          <div className="title-area text-center">
            <h2 className="sec-title">
              {t(`service.${currentService}.title`)}
            </h2>
          </div>
        )}
        {/* Resim alanları - Ulaşım Kolaylığı ve Yakın Mekanlar için yorum satırına alındı */}
        {/* 
        <div className="row gy-10 gx-10 justify-content-center align-items-center">
          {images.map((imageSrc, index) => (
            <div key={index} className="col-md-6 col-lg-2">
              <div className="gallery-card">
                <div className="box-img global-img">
                  <Link
                    to={imageSrc}
                    className="popup-image"
                    onClick={(e) => openModal(imageSrc, e)}
                  >
                    <div className="icon-btn">
                      <i className="fal fa-magnifying-glass-plus" />
                    </div>
                  </Link>
                  <img
                    src={imageSrc}
                    alt={getImageAltAndTitle(imageSrc, index).alt}
                    title={getImageAltAndTitle(imageSrc, index).title}
                    onClick={(e) => openModal(imageSrc, e)}
                    onError={(e) => {
                      e.target.src = "/assets/img/gallery/gallery_1_1.jpg";
                    }}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
        */}
        {serviceType === "transportation" ||
        serviceType === "nearby-places" ? null : (
          <div
            className={`row justify-content-center align-items-center ${
              serviceType === "nearby-universities"
                ? "gy-4 gx-4"
                : "gy-10 gx-10"
            }`}
          >
            {images.map((imageSrc, index) => (
              <div
                key={index}
                className={
                  serviceType === "nearby-universities"
                    ? "col-6 col-md-4 col-lg-3"
                    : "col-md-6 col-lg-2"
                }
              >
                <div className="gallery-card">
                  <div
                    className="box-img global-img"
                    style={
                      serviceType === "nearby-universities"
                        ? {
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            padding: "15px",
                            backgroundColor: "#fff",
                            minHeight: "150px",
                          }
                        : {}
                    }
                  >
                    <Link
                      to={imageSrc}
                      className="popup-image"
                      onClick={(e) => openModal(imageSrc, e)}
                    >
                      <div className="icon-btn">
                        <i className="fal fa-magnifying-glass-plus" />
                      </div>
                    </Link>
                    <img
                      src={imageSrc}
                      alt={getImageAltAndTitle(imageSrc, index).alt}
                      title={getImageAltAndTitle(imageSrc, index).title}
                      onClick={(e) => openModal(imageSrc, e)}
                      onError={(e) => {
                        e.target.src = "/assets/img/gallery/gallery_1_1.jpg";
                      }}
                      style={
                        serviceType === "nearby-universities"
                          ? {
                              objectFit: "contain",
                              maxWidth: "100%",
                              maxHeight: "150px",
                              width: "auto",
                              height: "auto",
                              imageRendering: "auto",
                            }
                          : {}
                      }
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
        <div
          className="shape-mockup d-none d-xl-block"
          style={{
            top: "-25%",
            left: "0%",
          }}
        >
          <img src="/assets/img/shape/line.png" alt="shape" />
        </div>
        <div
          className="shape-mockup movingX d-none d-xl-block"
          style={{
            top: "30%",
            left: "-3%",
          }}
        >
          <img
            className="gmovingX"
            src="/assets/img/shape/shape_4.png"
            alt="shape"
          />
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        closeModal={closeModal}
        imageSrc={modalImage}
        imageTitle={modalImageTitle}
      />
    </div>
  );
}

export default ServiceGallery;
